<template>
  <div class="todo-professional-visibility">
    <el-row type="flex">
      <el-col>
          <el-divider />
            <template>
              <el-form :model="serviceForm" ref="serviceForm" v-loading="loading">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="Select Service Industry" :rules="[{required: true}]">
                      <el-select v-model="serviceForm.serviceIndustry" @change="onServiceProviderChange($event)" placeholder="Select Service Industry" filterable>
                        <el-option
                          v-for="item in getServiceIndustryList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">{{item.name}}
                        </el-option>
                      </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="Select Service Type" :rules="[{required: true}]">
                      <el-select v-model="serviceForm.serviceType" placeholder="Select Service Type" filterable>
                          <el-option
                            v-for="item in getServicesTypeList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                          </el-option>
                      </el-select>
                      </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                  <el-col :span="2">
                    <el-form-item class="form-buttons">
                      <el-button type="primary" @click="onSubmit(serviceForm)">Search</el-button>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-form-item class="form-buttons">
                      <el-button @click="onClear(serviceForm)">Cancel</el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </template>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <h3>Pinned Professionals</h3>
    <div class="el-table el-table--fit el-table--scrollable-x el-table--scrollable-y el-table--enable-row-hover el-table--enable-row-transition" style="width: 100%;" v-loading="loading">
      <table cellspacing="0" cellpadding="0" border="0" class="el-table__header" style="width: 100%;">
        <thead class="has-gutter">
        <tr class="">
        <th class="is-leaf"><div class="cell">Sno</div></th>
        <th class="is-leaf"><div class="cell">Service Provider</div></th>
        </tr>
        </thead>
      </table>
      <div class="el-table__body-wrapper is-scrolling-left" >
        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 100%;">
          <template v-if="getPinnedProfessionalsList.length > 0">
            <draggable v-model="getPinnedProfessionalsList" tag="tbody">
              <tr v-for="(item,index) in getPinnedProfessionalsList" :key="item.profile_visibility.name">
                <td scope="row"><div class="cell">{{ index+1 }}</div></td>
                <td><div class="cell">{{ item.profile_visibility.name }}</div></td>
              </tr>
            </draggable>
          </template>
          <div v-else class="el-table__empty-block" style="height: 100%; width: 1080px;"><span class="el-table__empty-text">No Data</span></div>
        </table>
      </div>
    </div>
    <br>
    <el-row>
      <el-button type="primary" v-if="getPinnedProfessionalsList.length > 0" @click="onSaveVisibility(serviceForm)">Save Visibility</el-button>
    </el-row>
    <br>
    <h3>All Professionals</h3>
    <el-row type="flex" class="todo-provider">
       <el-col>
         <template>
          <el-table :data="getServicesList" style="width: 100%" height="400" v-loading="loading">
            <el-table-column
            type="index">
            </el-table-column>
            <el-table-column
              label="User Name"
              prop="name">
                <template slot-scope="scope">
                {{ scope.row.name }}
                </template>
            </el-table-column>
            <el-table-column
              label="Created Date"
              prop="createdDate">
              <template slot-scope="scope">
                {{ scope.row.created_at | formatDateWithoutTime }}
              </template>
            </el-table-column>
            <el-table-column width="150">
              <template slot-scope="scope">
                <template v-if="scope.row.profile_visibility_count >= 1">
                  <el-button type="warning" size="mini"
                  @click="handleActive(scope.row.id,'delete')">Unpin</el-button>
                </template>
                <template v-else>
                  <el-button type="success" size="mini"
                  @click="handleActive(scope.row.id,'add')">Pin</el-button>
                </template>
              </template>
            </el-table-column>
          </el-table>
         </template>
        </el-col>
    </el-row>
  </div>
</template>

<script>
  import { getServiceIndustry, getServiceType, getServices, setVisibility, deleteVisibility, getPinnedProfessionals, saveVisibility } from '@/api/visibility'
  import draggable from 'vuedraggable'
  export default {
    name: 'Visibility',
    props: {
    },
    components: {
      draggable
    },
    data() {
      return {
        loading: false,
        serviceForm: {
          serviceIndustry: '',
          serviceType: ''
        },
        getServiceIndustryList: [],
        getServicesTypeList: [],
        getServicesList: [],
        getPinnedProfessionalsList: []
      }
    },
    created: function() {
      this.getServiceIndustryListFunc()
    },
    methods: {
      onServiceProviderChange(event) {
        if (event) {
          this.getServicesTypeFunc(event)
          // console.log(event)
        }
      },
      async getServiceIndustryListFunc() {
        try {
          const { data } = await getServiceIndustry()
          this.getServiceIndustryList = data.data
        } catch (err) {
        }
        this.loading = false
      },
      async getServicesTypeFunc(providerId) {
        this.loading = true
        this.getServicesTypeList = []
        this.serviceForm.serviceType = ''
        try {
        const { data } = await getServiceType(providerId)
          this.getServicesTypeList = data.data
        } catch (err) {
        }
        this.loading = false
      },
      onSubmit() {
        this.loading = true
        this.getServicesFunc(this.serviceForm.serviceType)
        this.loading = false
      },
      async getServicesFunc(providerId) {
        this.loading = true
        this.getServicesList = []
        // this.serviceForm.serviceType = ''
        try {
        const { data } = await getServices(providerId)
          this.getServicesList = data
          // console.log(this.getServicesList)
          this.getPinnedProfessionalsFunc(this.serviceForm.serviceType)
        } catch (err) {
        }
        this.loading = false
      },
      async setVisibilityFunc(dataArr, type) {
        this.loading = true
        try {
          if (type === 'add') {
            const { data } = await setVisibility(dataArr)
            this.getServicesFunc(this.serviceForm.serviceType)
          }
          if (type === 'delete') {
            const { data } = await deleteVisibility(dataArr)
            this.getServicesFunc(this.serviceForm.serviceType)
          }
        } catch (err) {
        }
        this.loading = false
      },
      handleActive(profileId, type) {
        // console.log(profileId)
        const dataArr = {
          position: '',
          profileId: profileId,
          serviceTypeId: this.serviceForm.serviceType
        }
        this.setVisibilityFunc(dataArr, type)
      },
      async getPinnedProfessionalsFunc(serviceType) {
        this.loading = true
        try {
        const { data } = await getPinnedProfessionals(serviceType)
          this.getPinnedProfessionalsList = data
          // console.log(this.getPinnedProfessionalsList)
        } catch (err) {
        }
        this.loading = false
      },
      onSaveVisibility() {
        this.loading = true
        const positionArr = []
        const totalPinned = this.getPinnedProfessionalsList.length
        this.getPinnedProfessionalsList.forEach((row, index) => {
          positionArr.push({ serviceProviderId: row.profile_id, position: totalPinned - index, serviceTypeId: this.serviceForm.serviceType })
        })
        // console.log(positionArr)
        this.saveVisibilityFunc(positionArr)
        this.loading = false
      },
      async saveVisibilityFunc(positionArr) {
        this.loading = true
        try {
        const { data } = await saveVisibility(positionArr)
          // this.getPinnedProfessionalsList = data
          // console.log(this.getPinnedProfessionalsList)
          this.getPinnedProfessionalsFunc(this.serviceForm.serviceType)
        } catch (err) {
        }
        this.loading = false
      }
    }
  }
</script>

<style lang="scss">
  @import '../../../assets/variables';

  .form-buttons{
    margin-right: 5px;
  }

  .el-collapse-item .is-active {
    background-color: #e9e6e3;
  }
  .el-form{
    margin-top: 20px;
  }
  .el-collapse-item .el-collapse-item__header{
    padding-left: 5px;
  }
</style>
